import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopProjectTypeInfoResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopProjectTypeInfoRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.RequestCoopProjectTypeInfo), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.CoopProjectTypeInfo,
            props: {
                coopId: action.coopId,
                playerId: action.playerId,
            },
        });
    }), map(actionCoopProjectTypeInfoResponse), retry());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopProjectTypeInfoRequest.ts
// module id = 1822
// module chunks = 3